import { CerbosApplicationActions, CerbosApplicationKind } from '@repo/cerbos-types';
import { buildAbacPrincipal, buildApplicationAttributes } from '../abac';
import { getDecision } from '../decision';
const checkActions = async (organization, user, actions, application)=>{
    var _ref;
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosApplicationKind,
            id: (_ref = application === null || application === void 0 ? void 0 : application.id) !== null && _ref !== void 0 ? _ref : organization.id,
            attributes: buildApplicationAttributes(organization, application)
        },
        actions
    });
    return actions.map((action)=>decision.isAllowed(action));
};
export const canManageConfigKey = [
    'canManageUnmanagedApplication',
    CerbosApplicationActions.CREATE_UNMANAGED_APPLICATION,
    CerbosApplicationActions.UPDATE_UNMANAGED_APPLICATION,
    CerbosApplicationActions.DELETE_UNMANAGED_APPLICATION
].join('/');
export const getCanManageUnmanagedAppConfig = async (organization, user, application)=>{
    const [createUnmanagedApplication, updateUnmanagedApplication, deleteUnmanagedApplication] = await checkActions(organization, user, [
        CerbosApplicationActions.CREATE_UNMANAGED_APPLICATION,
        CerbosApplicationActions.UPDATE_UNMANAGED_APPLICATION,
        CerbosApplicationActions.DELETE_UNMANAGED_APPLICATION
    ], application);
    return {
        createUnmanagedApplication: createUnmanagedApplication !== null && createUnmanagedApplication !== void 0 ? createUnmanagedApplication : false,
        updateUnmanagedApplication: updateUnmanagedApplication !== null && updateUnmanagedApplication !== void 0 ? updateUnmanagedApplication : false,
        deleteUnmanagedApplication: deleteUnmanagedApplication !== null && deleteUnmanagedApplication !== void 0 ? deleteUnmanagedApplication : false
    };
};
